export type CplAuthRequiredReason =
    | 'no-session'
    | 'guard'
    | 'token-expired'
    | 'refresh-failed'
    | 'init-failed';

export type CplToastLevel = 'success' | 'error' | 'warning' | 'info';

export type CplMessageBase = {
    source: 'cpl';
};

export type CplAuthRequiredMessage = CplMessageBase & {
    type: 'cpl:auth-required';
    reason: CplAuthRequiredReason;
};

export type CplToastMessage = CplMessageBase & {
    type: 'cpl:toast';
    level: CplToastLevel;
    message: string;
};

export type CplMessage = CplAuthRequiredMessage | CplToastMessage;

export const isCplMessage = (data: unknown): data is CplMessage =>
    typeof data === 'object' &&
    data !== null &&
    (data as CplMessageBase).source === 'cpl' &&
    typeof (data as { type?: unknown }).type === 'string';
